import { ThreeEvent } from '@react-three/fiber';
import { useCallback, useMemo, useRef } from 'react';

const MAX_CLICK_DISTANCE_PX = 6;

export function use3DRightClick(
  onRightClick: ((event: ThreeEvent<PointerEvent>) => void) | undefined
) {
  const startRef = useRef<{ x: number; y: number } | null>(null);

  const onPointerDown = useCallback((event: ThreeEvent<PointerEvent>) => {
    if (event.button !== 2) return;
    startRef.current = {
      x: event.nativeEvent.clientX,
      y: event.nativeEvent.clientY
    };
    const target = event.target as unknown as {
      setPointerCapture?: (pointerId: number) => void;
    };
    target.setPointerCapture?.(event.pointerId);
  }, []);

  const onPointerUp = useCallback(
    (event: ThreeEvent<PointerEvent>) => {
      if (event.button !== 2) return;
      const target = event.target as unknown as {
        releasePointerCapture?: (pointerId: number) => void;
      };
      target.releasePointerCapture?.(event.pointerId);
      const start = startRef.current;
      startRef.current = null;
      if (!start || !onRightClick) return;

      const distance = Math.hypot(
        event.nativeEvent.clientX - start.x,
        event.nativeEvent.clientY - start.y
      );
      if (distance <= MAX_CLICK_DISTANCE_PX) {
        onRightClick(event);
      }
    },
    [onRightClick]
  );

  return useMemo(
    () => ({ onPointerDown, onPointerUp }),
    [onPointerDown, onPointerUp]
  );
}
